import * as yup from 'yup';
import { VideoType } from '@shared/types/common';

export interface PromoFormValues {
  screenshot_url?: File | string;
  title: string;
  url?: string;
  video_type: VideoType;
  file?: File | string;
}

export const promoCreateSchema = yup
  .object()
  .shape({
    screenshot_url: yup.mixed().required('Загрузите обложку'),
    file: yup.mixed().nullable(),
    video_type: yup.string(),
    url: yup.string(),
  })
  .test({
    name: 'video is required',
    test: (value, ctx) => {
      switch (value.video_type) {
        case 'Y':
          if (!value.url || !value.url.length) {
            return ctx.createError({
              message: 'Не добавлена ссылка',
              path: 'video',
            });
          }
          break;

        case 'B':
          if (!value.file) {
            return ctx.createError({
              message: 'Не добавлен видеофайл',
              path: 'video',
            });
          }
          break;
        default:
          break;
      }
      return true;
    },
  });

export const promoUpdateSchema = yup.object().shape({
  screenshot_url: yup.mixed().required('Загрузите обложку'),
});
